export const environment = {
  production: true,
  version: "%%version%%"
};
